module.exports = {"430722001":"龙阳街道","430722002":"辰阳街道","430722003":"沧浪街道","430722004":"株木山街道","430722101":"蒋家嘴镇","430722102":"岩汪湖镇","430722103":"坡头镇","430722104":"酉港镇","430722105":"洲口镇","430722106":"罐头嘴镇","430722107":"沧港镇","430722108":"朱家铺镇","430722109":"太子庙镇","430722111":"崔家桥镇","430722112":"军山铺镇","430722113":"百禄桥镇","430722114":"西湖镇","430722115":"洋淘湖镇","430722117":"丰家铺镇","430722118":"龙潭桥镇","430722205":"聂家桥乡","430722206":"毛家滩回族维吾尔族乡","430722501":"西湖管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430722.json
// module id = 1873
// module chunks = 0